import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { NgClass } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CreateActionType } from './create-action.types';

export { CreateActionType } from './create-action.types';

@Component({
  selector: 'lib-create-action-modal',
  templateUrl: './create-action-modal.component.html',
  styleUrls: ['./create-action-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, NgClass]
})
export class CreateActionModalComponent {
  static selectedAction: CreateActionType = CreateActionType.GAME;

  readonly selected: WritableSignal<CreateActionType> = signal(CreateActionType.GAME);
  readonly CreateActionType: typeof CreateActionType = CreateActionType;

  constructor() {
    CreateActionModalComponent.selectedAction = CreateActionType.GAME;
  }

  select(type: CreateActionType): void {
    this.selected.set(type);
    CreateActionModalComponent.selectedAction = type;
  }
}
